import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setShareLevel } from '../../../store/actions/share'
import ShareUser from './ShareUser'
import { userIdSelector } from '../../../store/selectors/baseSelectors'
import { Formik } from 'formik'
import { withTranslation } from 'react-i18next'
import { compose } from 'recompose'
import { confirm } from '../../../store/actions/alerts'

const enhance = compose(
  withTranslation(),
  connect(
    state => ({
      userId: userIdSelector(state)
    }),
    (dispatch, { item, share, t }) => ({
      setShareLevel: accessLevel => {
        const action = () => dispatch(setShareLevel({ share, accessLevel }))

        if (share.accessLevel < accessLevel) return action()

        const warning = item.folders
          ? 'share.confirmRemoveNested'
          : 'share.confirmRemove'
        return dispatch(
          confirm(warning, action, {
            count: item.folders ? item.folders.length : 0,
            user: share.user.displayName || share.user.email,
            type: item.type
          })
        )
      }
    })
  )
)

export const ShareUserContainer = ({ setShareLevel, ...props }) => (
  <Formik
    onSubmit={({ shareLevel }) => {
      setShareLevel(parseInt(shareLevel, 10))
    }}
    initialValues={{ shareLevel: props.share.accessLevel }}
    render={formikProps => <ShareUser {...props} {...formikProps} />}
  />
)

ShareUserContainer.propTypes = {
  setShareLevel: PropTypes.func.isRequired,
  share: PropTypes.object.isRequired
}

export default enhance(ShareUserContainer)
